module.exports = __webpack_public_path__ + "img/0Q3A2361_L_Black.f3a5887b.jpg";